import React from 'react';
import marked from 'marked';
import { renderToString } from 'react-dom/server';
import { UnstyledLink as Link } from '../ui';
import { Type } from '@spotify-internal/encore-web';

export class DefaultRenderer extends marked.Renderer {
  link(...args: any[]) {
    return renderLink.apply(this, args as [any, any, any]);
  }

  paragraph(text: string) {
    return super.paragraph(spotifyWidgetParagraph(text));
  }

  heading(text: string, level: 1 | 2 | 3 | 4) {
    const variant = `heading${level}` as
      | 'heading1'
      | 'heading2'
      | 'heading3'
      | 'heading4';
    const typeAs = `h${level}` as 'h1' | 'h2' | 'h3' | 'h4';
    return renderToString(
      <Type
        as={typeAs}
        variant={variant}
        dangerouslySetInnerHTML={{ __html: text }}
      />,
    );
  }

  hr() {
    return '';
  }
}

/**
 * Renders a link, external by default
 *
 * @example: [Spotify for Artists](https://artists.spotify.com/ "internal")
 */
export const renderLink = (href: string, title: string, text: string) => {
  return renderToString(
    <Link
      external={title !== 'internal'}
      track={['External Link', `Content Link - ${href}`]}
      href={href}
    >
      <span dangerouslySetInnerHTML={{ __html: text || title }} />
    </Link>,
  );
};

export const spotifyWidgetParagraph = (text: string) => {
  if (text.indexOf('[play-button') === 0) {
    const [
      ,
      uri,
      compact,
    ] = /\[play-button\s+(spotify:[\w:]+)(?:\s+(compact))?\]/g.exec(
      text,
    ) as any[];
    const height = compact === 'compact' ? 80 : 380;

    return `<iframe
      src="https://open.spotify.com/embed?uri=${uri}"
      width="300"
      height="${height}"
      frameborder="0"
      allowtransparency="true"
      allow="encrypted-media">
    </iframe>`;
  }

  return text;
};
